import { Component, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute }  from '@angular/router';

declare var $;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class AppComponent {

	constructor (
  	private route: ActivatedRoute,
		private router: Router
	) {}

  onActivate(e, outlet){
		window.scrollTo(0, 0);
  }

  goHome() {
		this.router.navigate(['/']);
  }

  goHomePage() {
  	$('.navbar-collapse').collapse('hide');
		this.router.navigate(['/home']);
  }

  goFor() {
  	$('.navbar-collapse').collapse('hide');
		this.router.navigate(['/for-restaurants']);
  }

  isIfrme(): boolean{
  	return this.route.snapshot.queryParams['iframe'] == 'true';
  }
}


// WEBPACK FOOTER //
// /Users/nikolay/Documents/GitHub/menu-web/src/app/app.component.ts